const Redirect = ({ to }) => {
	window.location.href = to;
	return (
		<p>Redirecting to an external site. Click <a href={to}>here</a> if not redirected automatically.</p>
	);
}

export default Redirect;
